export default class PropertyValue<T> {
    private _value: T;
    public get value() { return this._value; }
    public set value(x: T) { this._value = x; }

    constructor(initialValue: T) {
        this._value = initialValue;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/property-value.ts